import { useMediaQuery } from 'react-responsive';

function useIsMobile(mobileMaxWidth = 576) {
  return useMediaQuery({ maxWidth: mobileMaxWidth });
}

export default useIsMobile;
